var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { staticClass: "p-3" },
        [
          _c(
            "b-overlay",
            { attrs: { show: _vm.consultantoElBack } },
            [
              !_vm.formularioHabilitado
                ? _c(
                    "b-row",
                    [
                      _c(
                        "b-col",
                        [
                          _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _c("strong", [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.formalizacionFormato1Snp.mensajes.formularioHabilitado"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("h5", [
                              _c("strong", [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.formalizacionFormato1Snp.mensajes.firmantes"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "py-2 area-responsive area-responsive-listado",
                            },
                            [
                              _c(
                                "b-list-group",
                                _vm._l(_vm.firmantes, function (firmante) {
                                  return _c(
                                    "b-list-group-item",
                                    { key: firmante.ordenDeFirma },
                                    [
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", lg: "6" } },
                                            [
                                              _c("strong", [
                                                _c("span", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.formalizacionFormato1Snp.campos.cvu"
                                                        ) + ": "
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    firmante.cvu
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", lg: "6" } },
                                            [
                                              _c("strong", [
                                                _c("span", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.formalizacionFormato1Snp.campos.firmado"
                                                        ) + ": "
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              firmante.firmado
                                                ? _c("span", {
                                                    staticClass: "text-success",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.formalizacionFormato1Snp.campos.si"
                                                        )
                                                      ),
                                                    },
                                                  })
                                                : _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.formalizacionFormato1Snp.campos.no"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", lg: "6" } },
                                            [
                                              _c("strong", [
                                                _c("span", {
                                                  domProps: {
                                                    textContent: _vm._s(
                                                      _vm.$t(
                                                        "apeironGwApp.formalizacionFormato1Snp.campos.orden"
                                                      ) + ": "
                                                    ),
                                                  },
                                                }),
                                              ]),
                                              _vm._v(" "),
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    firmante.ordenDeFirma
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "b-col",
                                            { attrs: { cols: "12", lg: "6" } },
                                            [
                                              !!firmante.fechaFirma
                                                ? _c("span", {
                                                    staticClass: "text-success",
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        firmante.fechaFirma
                                                      ),
                                                    },
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              firmante.ordenDeFirma ==
                                              _vm.firmanteActual.ordenDeFirma
                                                ? _c(
                                                    "strong",
                                                    [
                                                      _c(
                                                        "b-badge",
                                                        {
                                                          attrs: {
                                                            variant: "success",
                                                          },
                                                        },
                                                        [
                                                          _c("span", {
                                                            domProps: {
                                                              textContent:
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "apeironGwApp.formalizacionFormato1Snp.campos.firmanteActual"
                                                                  )
                                                                ),
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("strong", [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.formalizacionFormato1Snp.campos.nombre"
                                                    ) + ": "
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  firmante.nombre
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-row",
                                        [
                                          _c("b-col", [
                                            _c("strong", [
                                              _c("span", {
                                                domProps: {
                                                  textContent: _vm._s(
                                                    _vm.$t(
                                                      "apeironGwApp.formalizacionFormato1Snp.campos.tituloDeFirma"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]),
                                            _vm._v(" "),
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  firmante.tituloFirma
                                                ),
                                              },
                                            }),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    [
                      _c("h5", [
                        _c("strong", [
                          _c("span", {
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t(
                                  "apeironGwApp.formalizacionFormato1Snp.mensajes.accionesFirma"
                                )
                              ),
                            },
                          }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "p-4" },
                            [
                              _c("firmar-formato1-snp", {
                                attrs: {
                                  solicitudId: _vm.solicitud.id,
                                  personalBeca: _vm.personalBecasSesion,
                                  permitirFirmar:
                                    _vm.personalBecasSesion.cvu ==
                                      _vm.firmanteActual.cvu &&
                                    _vm.formularioHabilitado,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.manejaFirmado($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }